import { render } from "./FacultyLoad.vue?vue&type=template&id=f76788b6"
import script from "./FacultyLoad.vue?vue&type=script&lang=js"
export * from "./FacultyLoad.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__